import React from 'react';
import PropTypes from 'prop-types';

import CodeEditor from './CodeEditor';
import FinalLock from './FinalLock';

class Step4 extends React.Component {
  constructor() {
    super();
    this.stop = false;
  }
  state = {
    finalSlide2: false,
    finalSlide1: true,
    typing1: true
  };

  componentWillUnmount() {
    clearTimeout(this.loadInterval);
    this.loadInterval = false;
    this.stop = true;
  }

  setStatePromise = (newState, delay) =>
    new Promise(resolve => {
      this.loadInterval = setTimeout(() => {
        if (this.stop) return resolve();
        return this.setState(newState, () => {
          resolve();
        });
      }, delay);
    });

  finalSlide = () => {
    this.setStatePromise(
      { finalSlide1: false, finalSlide2: true, typing1: false },
      2000
    ).then(() => {
      this.props.setStep(1, 4000);
    });
  };

  render() {
    return (
      <div>
        {this.state.finalSlide2 && <FinalLock visibility={this.state.finalSlide2} />}
        <CodeEditor
          onDone1={this.finalSlide}
          typing1={this.state.typing1}
          visibility={this.state.finalSlide1}
        />
      </div>
    );
  }
}

Step4.propTypes = {
  setStep: PropTypes.func.isRequired
};

export default Step4;



// WEBPACK FOOTER //
// ./src/pages/jp/homepage/components/OnboardingFlow/components/Step4.js